const headerMenu = () => {
    const body = document.body;
    const header = document.querySelector('.header');
    const btnMobMenu = document.querySelector('.btn-mob-menu');
    const headerNav = document.querySelector('.header__nav');
    const headerNavMobile = document.querySelector('.header__nav.mobile');
    const headerNavDesktop = document.querySelector('.header__nav.desktop');
    let winWidth = window.innerWidth;

    headerNavDesktop.addEventListener('mouseover', function ({target}) {

        const parentHasChildrenFirstLvl = headerNavDesktop.querySelectorAll('.desktop > .menu-item-has-children');

        for (const liItem of parentHasChildrenFirstLvl) {
            const ul = liItem.querySelector('.sub-nav-list');
            const lisQuantity = [...ul.querySelectorAll('.menu-item')];

            let allLisHeight = lisQuantity.reduce(function (accumulator, currentLi) {
                return accumulator + (currentLi.offsetHeight);
            }, 0);

            allLisHeight = parseInt(allLisHeight);
            const transparentSpan = liItem.querySelector('.transparent-background');
            transparentSpan.style.height = `${allLisHeight}px`;
        }

        setParentAttr(target, 'true');
    });

    headerNavDesktop.addEventListener('mouseout', function ({target}) {
        const allTransparentSpans = document.querySelectorAll('.transparent-background');

        for (const transparentSpan of allTransparentSpans) {
            transparentSpan.style.height = 0;
        }

        if (!target.getAttribute('aria-expanded')) {
            target.setAttribute('aria-expanded', 'false');
        } else {
            setParentAttr(target, 'false');
        }
    });


    if (headerNav.classList.contains('desktop')) {

        const headerNavDesktop = document.querySelector('.header__nav.desktop');
        const parentHasChildren = headerNavDesktop.querySelectorAll('.desktop .menu-item-has-children');
        const parentHasChildrenFirstLvl = headerNavDesktop.querySelectorAll('.desktop > .menu-item-has-children');
        const firstLiMenu = document.querySelectorAll('.header__nav.desktop > .menu-item');

        for (const li of firstLiMenu) {
            li.querySelector('a').addEventListener('focus', function () {
                const subNavMenusActive = document.querySelectorAll('.sub-nav-list.active');
                if (subNavMenusActive.length !== 0) {
                    for (const subNavMenu of subNavMenusActive) {
                        subNavMenu.classList.remove('active');
                    }
                }
            });
        }

        for (const item of parentHasChildrenFirstLvl) {
            const subNavMenu = item.querySelector('.sub-nav-list');
            const itemClone = item.cloneNode(true);
            const subNavMenuClone = itemClone.querySelector('.sub-nav-list');
            itemClone.removeChild(subNavMenuClone);
            itemClone.classList.remove('menu-item-has-children');
            subNavMenu.insertBefore(itemClone, subNavMenu.firstChild);
        }

        for (const item of parentHasChildren) {
            const subNavMenu = item.querySelector('.sub-nav-list');
            let timer;
            const link = item.querySelector('a');
            const linkText = link.innerText;

            link.setAttribute('aria-label', linkText);
            link.setAttribute('aria-expanded', 'false');

            link.addEventListener('keypress', function (e) {
                if (e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault();
                    const dropdown = this.nextElementSibling;

                    removeAllExpAttr(parentHasChildren);

                    if (dropdown.classList.contains('active')) {
                        dropdown.classList.remove('active');
                    } else {
                        link.blur();
                        dropdown.classList.add('active');
                        link.setAttribute('aria-expanded', 'true');
                        link.setAttribute('aria-label', linkText);
                        const firstLink = dropdown.querySelector('a');
                        setTimeout(function () {
                            firstLink.focus();
                        }, 100);
                    }
                }
            });

            link.addEventListener('focus', function () {
                link.focus();

                if (subNavMenu.classList.contains('active')) {
                    subNavMenu.classList.remove('active');
                }
            });

            subNavMenu.addEventListener('focusout', function () {
                setTimeout(function () {
                    if (!subNavMenu.classList.contains('active')) {
                        link.setAttribute('aria-expanded', 'false');
                    }
                }, 1);
            });

            link.addEventListener('mouseover', function () {
                clearTimeout(timer);
                removeAllExpAttr(parentHasChildren);
                link.setAttribute('aria-expanded', 'true');
            });
        }
    }

    function setParentAttr(target, value) {
        const parent = target.closest('.parent-1')?.querySelector('.lvl-1');
        if (parent) {
            parent.setAttribute('aria-expanded', value);
        }
    }

    function toggleScroll() {
        if (body.classList.contains('fixed')) {
            const scrollY1 = body.style.top;
            body.style.position = "";
            body.style.top = "";
            body.style.left = "";
            body.style.right = "";
            window.scrollTo(0, parseInt(scrollY1 || "0") * -1);
            body.classList.remove('fixed');
        } else {
            body.classList.add('fixed');
            const scrollY = (body.style.top = `-${window.scrollY}px`);
            body.style.position = "fixed";
            body.style.top = scrollY + "px";
            body.style.left = 0;
            body.style.right = 0;
        }
    }

    if (btnMobMenu) {
        btnMobMenu.addEventListener('click', function (e) {
            e.preventDefault();
            btnMobMenu.classList.toggle('open');
            header.classList.toggle('active');
            toggleScroll();
            headerNavMobile.classList.toggle('active');
            removeAllActiveClasses();
        });
    }

    function removeAllExpAttr(elList) {
        if (!elList.length) return;

        for (const el of elList) {
            el.querySelector('a').setAttribute('aria-expanded', 'false');
        }
    }

    function toggleSubNavVisibility(element, current) {
        let subNavList = current === 'arrow' ? element.nextElementSibling : element.nextElementSibling.nextElementSibling;

        if (subNavList && subNavList.classList.contains('sub-nav-list')) {
            const isSubNavActive = subNavList.classList.contains('active');

            const siblingSubNavLists = element.parentElement.parentElement.querySelectorAll('.sub-nav-list');
            siblingSubNavLists.forEach(sibling => {
                if (sibling !== subNavList) {
                    sibling.style.maxHeight = '0';
                    sibling.classList.remove('active');
                    const siblingArrowButton = sibling.previousElementSibling;
                    if (siblingArrowButton) {
                        siblingArrowButton.classList.remove('active');
                    }
                }
            });

            if (element.classList.contains('lvl-0')) {
                subNavList.style.maxHeight = isSubNavActive ? '0' : '100%';
            } else {
                subNavList.style.maxHeight = isSubNavActive ? '0' : subNavList.scrollHeight + 'px';
            }

            subNavList.classList.toggle('active');

            if (current === 'arrow') {
                element.classList.toggle('active', !isSubNavActive);
            } else if (current === 'link') {
                const button = element.nextElementSibling;
                if (button && button.classList.contains('arrow-down')) {
                    button.classList.toggle('active', !isSubNavActive);
                }
            }
        }
    }

    headerNavMobile.addEventListener('click', function (event) {
        const target = event.target;
        let el = '';

        if (target.classList.contains('arrow-down')) {
            el = 'arrow';
            toggleSubNavVisibility(target, el);
        }

        if (target.tagName === 'A' && target.getAttribute('href') === '#') {
            el = 'link';
            event.preventDefault();
            toggleSubNavVisibility(target, el);
        }
    });

    function removeAllActiveClasses() {
        const allSubNavLists = headerNavMobile.querySelectorAll('.sub-nav-list');
        allSubNavLists.forEach(list => {
            list.style.maxHeight = '0';
            list.classList.remove('active');
            const arrowButton = list.previousElementSibling;
            if (arrowButton.classList.contains('arrow-down')) {
                arrowButton.classList.remove('active');
            }
        });
    }

    window.addEventListener('resize', function () {
        if (btnMobMenu.classList.contains('open') && winWidth !== window.innerWidth) {
            btnMobMenu.click();
            removeAllActiveClasses();
        }

        winWidth = window.innerWidth;
    });

}

export default headerMenu;
